import { render, staticRenderFns } from "./AIReportConfig.vue?vue&type=template&id=5f34cac5&scoped=true"
import script from "./AIReportConfig.vue?vue&type=script&lang=js"
export * from "./AIReportConfig.vue?vue&type=script&lang=js"
import style0 from "./AIReportConfig.vue?vue&type=style&index=0&id=5f34cac5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34cac5",
  null
  
)

export default component.exports